import { Menu, MenuItem } from '@nike/eds';
import { RANKING_RULE_TARGET_TYPES } from 'constants/index';
import { useSetAtom } from 'jotai';
import { rankingRuleTargetModalAtom } from 'atoms/ranking';
import { RankingRuleActionType } from 'types/ranking';

function TargetMenuBody({
  onMenuClick,
}: {
  onMenuClick: (s: string) => (ev: React.MouseEvent<HTMLButtonElement>) => void;
}) {
  return (
    <>
      <MenuItem onClick={onMenuClick(RANKING_RULE_TARGET_TYPES.STYLE_COLOR)}>
        Style Color
      </MenuItem>
      <MenuItem onClick={onMenuClick(RANKING_RULE_TARGET_TYPES.STYLE_CODE)}>
        Style Code
      </MenuItem>
      <MenuItem onClick={onMenuClick(RANKING_RULE_TARGET_TYPES.PBID)}>
        PBID
      </MenuItem>
      <MenuItem onClick={onMenuClick(RANKING_RULE_TARGET_TYPES.TAXONOMY)}>
        Taxonomy
      </MenuItem>
      <MenuItem onClick={onMenuClick(RANKING_RULE_TARGET_TYPES.PRICE)}>
        Price
      </MenuItem>
    </>
  );
}

export function TargetMenu(props: {
  children: React.ReactNode;
  actionType: RankingRuleActionType;
  isOpen: boolean;
  closeMenu: () => void;
}) {
  const setTargetModal = useSetAtom(rankingRuleTargetModalAtom);
  const onTargetMenuClick = (type: string) => {
    return () => {
      props.closeMenu();
      // setTargetMenuOpen(false);
      setTargetModal((modalData) => {
        modalData.visible = true;
        modalData.type = type;
        modalData.actionType = props.actionType;
      });
    };
  };

  return (
    <Menu
      onClickOutside={props.closeMenu}
      isOpen={props.isOpen}
      bodySlot={<TargetMenuBody onMenuClick={onTargetMenuClick} />}
      placement='right'
    >
      {props.children}
    </Menu>
  );
}
